export const Like = ({ ...props }) => {
  return (
    <svg
      height="800px"
      width="800px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 232.665 232.665"
      {...props}
    >
      <title>Like</title>
      <g>
        <path
          style={{ fill: '#FFD4C4' }}
          d="M192.728,128.895c-1.007-1.882-0.501-4.233,1.175-5.554c9.77-7.697,10.3-34.01-8.552-34.01h-48.991
        c-9.59,0-15.655-10.324-10.984-18.7c5.74-10.292,9.922-21.717,13.939-34.52c4.34-13.83-4.379-24.107-14.482-24.107
        c-5.383,0-11.156,2.911-15.562,9.756C96.597,41.452,87.672,64.079,75.246,76.133c-9.818,9.517-43.171,28.936-43.171,30.14v79.825
        c0,2.254,1.728,4.17,3.956,4.511l28.828,4.403c0.644,0.099,1.283,0.339,1.827,0.696c25.968,17.054,49.343,24.957,68.432,24.957
        c5.143,0,9.981-0.574,14.471-1.697c22.348-5.586,23.769-19.317,22.86-26.447c-0.294-2.302,1.164-4.408,3.406-5.006
        c11.944-3.181,12.495-19.43,8.711-27.308c-1.057-2.201-0.042-4.788,2.108-5.944C195.587,149.471,196.246,135.468,192.728,128.895z"
        />
        <path
          d="M205.428,128.634c6.81-8.589,9.181-22.092,5.294-33.304c-3.91-11.281-13.395-17.998-25.371-17.998h-48.991
        c-0.162,0-0.33-0.019-0.497-0.302c-0.161-0.276-0.086-0.42-0.007-0.562c6.795-12.183,11.35-25.426,14.908-36.767
        c3.221-10.264,1.771-20.64-3.975-28.465C141.624,4.201,133.416,0,124.832,0c-10.059,0-19.409,5.563-25.652,15.264
        c-4.906,7.623-9.152,15.453-13.258,23.025C79.539,50.06,73.511,61.177,66.974,67.518c-5.227,5.066-20.685,15.003-29.922,20.939
        c-3.312,2.13-6.256,3.968-8.368,5.386c-3.799,2.55-8.61,5.723-8.61,12.43v79.825c0,8.241,5.996,15.127,14.142,16.373l27.227,4.158
        c26.337,17.039,51.792,26.036,73.664,26.036c6.078,0,11.935-0.691,17.388-2.056c12.962-3.24,22.223-9.323,27.514-18.08
        c3.309-5.476,4.446-11.006,4.613-15.684c4.776-2.615,8.59-6.74,11.017-12.013c3.602-7.825,3.639-16.661,1.9-23.703
        C206.552,152.76,208.235,138.778,205.428,128.634z M186.674,154.263c-2.15,1.156-3.165,3.743-2.108,5.944
        c3.784,7.878,3.233,24.127-8.71,27.308c-2.242,0.598-3.699,2.704-3.405,5.006c0.909,7.13-0.509,20.861-22.857,26.447
        c-4.491,1.123-9.322,1.697-14.467,1.697c-19.089,0-42.453-7.903-68.421-24.957c-0.544-0.357-1.162-0.598-1.806-0.696l-28.871-4.403
        c-2.228-0.341-3.956-2.257-3.956-4.511v-79.825c0-1.204,33.353-20.624,43.171-30.142c12.427-12.053,21.31-34.681,33.983-54.373
        c4.405-6.845,10.201-9.759,15.584-9.759c10.103,0,18.831,10.273,14.493,24.104c-4.018,12.804-8.195,24.237-13.934,34.529
        c-4.672,8.376,1.399,18.7,10.989,18.7h48.991c18.852,0,18.321,26.312,8.552,34.01c-1.676,1.32-2.182,3.682-1.175,5.562
        C196.246,135.477,195.588,149.471,186.674,154.263z"
        />
      </g>
    </svg>
  );
};
